module.exports = __webpack_public_path__ + "img/app_icon2.09c0922e.png";